export default __webpack_public_path__ + "static/media/about_img2.39c1e8c5.jpg";